{
    "PromptDeletereport": "Sind Sie sicher, dass Sie löschen möchten?",
    "PromptDeletereports": "Möchten Sie die ausgewählten Berichte wirklich dauerhaft löschen?",
    "PromptEmptyrecyclebin": "Möchten Sie wirklich alle Berichte im Papierkorb endgültig löschen?",
    "PromptRemovereport": "Möchten Sie diesen Bericht wirklich entfernen?",
    "PromptReportswillbedeletedpermanently": "Berichte werden endgültig gelöscht und können nicht wiederhergestellt werden.",
    "AreYouSureDelete": "Sind Sie sicher, dass Sie löschen möchten?",
    "AreYouSureRemove": "Möchten Sie diesen Bericht wirklich entfernen?",
    "LanguagePrompt_PromptConfirm": "Bestätigen",
    "LanguagePrompt_PromptCancel": "Absagen",
    "NAME": "LanguagePrompt"
}